import React, { useState, useEffect } from 'react';
import cx from 'classnames';
import styles from './index.module.scss.js';

const CheckBox = ({
  id,
  name,
  checked,
  v2 = true,
  onChange = () => {
  },
  children,
  errors,
  disabled,
  className,
  style
}) => {
  const [val, setVal] = useState(checked || false);
  useEffect(() => {
    setVal(checked);
  }, [checked]);
  return /* @__PURE__ */ React.createElement(
    "div",
    {
      className: cx(styles.box, className, {
        [styles.invalid]: !!errors
      }),
      style
    },
    /* @__PURE__ */ React.createElement(
      "input",
      {
        name,
        type: "checkbox",
        id: String(id),
        checked: val,
        onChange: (e) => {
          setVal(e.target.checked);
          onChange(e.target.checked);
        },
        disabled,
        "aria-label": name,
        className: cx({
          [styles.v2]: v2
        })
      }
    ),
    /* @__PURE__ */ React.createElement("label", { className: styles.label, htmlFor: String(id) }, /* @__PURE__ */ React.createElement("span", null), children)
  );
};
CheckBox.displayName = "CheckBox";

export { CheckBox };
//# sourceMappingURL=index.js.map
